export class OAuthApp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "callbackURLs",
            "baseName": "callbackURLs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "authUrl",
            "baseName": "authUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenUrl",
            "baseName": "tokenUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "OAuthAppTypeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OAuthApp.attributeTypeMap;
    }
    constructor() {
    }
}
export var OAuthAppTypeEnum;
(function (OAuthAppTypeEnum) {
    OAuthAppTypeEnum["GcpGemini"] = "gcp-gemini";
})(OAuthAppTypeEnum || (OAuthAppTypeEnum = {}));
